module.exports = __webpack_public_path__ + "img/004.4cc2ea68.jpg";